import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRmaApi} from "../../../../api/support/RMA";
import {useState} from "react";
import {useModal} from "../../../../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";

export default function useDeleteRma() {
    const [checkedList, setCheckedList] = useState<number[]>([]);
    const {handleModal} = useModal();
    const queryClient = useQueryClient();
    const { goToNavigation } = useGoToNavigation();

    const res = useMutation({
        mutationFn: (data: number[]) => deleteRmaApi({rmaIdList: data}),
        onSuccess: (res, variables) => {
            queryClient.invalidateQueries({
                queryKey: ["readRmaList"],
            });
            queryClient.invalidateQueries({
                queryKey: ["readRmaDetail"],
            });
            setCheckedList([]);
            goToNavigation("support/rma/list?pageNo=1", {}, false)
        },
        onError: (error) => {
            console.log("update error", error);
        },
    })

    const addRemovedCheckedList = (id: number) => {
        if (checkedList.includes(id)) {
            setCheckedList(checkedList.filter((item) => item !== id));
        } else {
            setCheckedList([...checkedList, id]);
        }
    }

    const addRemoveCheckedListAll = (id: number[]) => {
        const newCheckedList = id.filter((id) => !checkedList.includes(id));
        if (newCheckedList.length > 0)
            setCheckedList([...checkedList, ...newCheckedList]);
        else
            setCheckedList(checkedList.filter((item) => !id.includes(item)));
    }

    const deleteCheckedRma = () => {
        if (checkedList.length > 0) {
            handleModal({
                isOpen: true,
                contents: '삭제하시겠습니까?',
                type: "confirm",
                title: '알림',
                callback: () => {
                    res.mutate(checkedList);
                }
            });
        } else {
            handleModal({
                isOpen: true,
                contents: "선택된 항목이 없습니다.",
                type: "alert",
            });
        }
    }

    const deleteRma = (id: number) => {
        handleModal({
            isOpen: true,
            contents: 'RMA를 삭제하시겠습니까?',
            type: "confirm",
            title: '알림',
            callback: () => {
                res.mutate([id]);
            },
        });
    }

    return {res, addRemovedCheckedList, addRemoveCheckedListAll, checkedList, deleteCheckedRma, deleteRma};
}